import styles from "./styles/overview.module.scss";
import { Box, Typography } from "@mui/material";
import { useConsole, useUser } from "contexts";
import useInstall from "hooks/usePWAInstall";
import { Flex, IconButton, Image } from "ui";

export function Overview() {
  const { isReadyForInstall, downloadPWA } = useInstall();
  const { screen } = useConsole();
  const { profile } = useUser();

  if (!screen.isMobile) return null;

  return (
    <Box className={styles.container}>
      <Box className={styles.logo}>
        <Image src="/isotipo.svg" alt="Logo" width={40} height={40} />
        <Typography variant="body1">monus</Typography>
      </Box>
      <Flex className={styles.install} hidden={!isReadyForInstall}>
        <IconButton
          icon={screen.isMobile ? "install_mobile" : "install_desktop"}
          onClick={downloadPWA}
          variant="installer"
          rounded
        />
      </Flex>
      <Typography variant="h1">
        {profile?.name ? `Hola ${profile.firstName}.` : "¡Bienvenido!"}
      </Typography>
      <img className={styles.cloud} src="/assets/home/cloud.svg" alt="cloud" />
    </Box>
  );
}

/*
 <img
  className={styles.elements}
  src="/assets/home/elements.svg"
  alt="elements"
/>
*/
